"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const address_1 = __importDefault(require("../../address"));
const contact_1 = __importDefault(require("../../contact"));
class Broker extends contact_1.default {
    constructor(data) {
        super(data.id, data.name, data.email, data.address, data.phone);
        this.office = data.office;
        this.partnerId = data.partnerId;
    }
    static fromObj(data) {
        if (!data) {
            return Broker.empty();
        }
        return new Broker(Object.assign(Object.assign({}, data), { address: data.address ? address_1.default.fromObj(data.address) : address_1.default.empty() }));
    }
    static empty() {
        const data = Object.assign(Object.assign({}, contact_1.default.empty()), { office: "", partnerId: "" });
        return new Broker(data);
    }
}
exports.default = Broker;
//# sourceMappingURL=broker.class.js.map